@if (isTerminated) {
  <main class="h-96 py-20">
    <div class="space-y-4">
      <div class="w-full flex align-middle justify-center">
        <div class="w-24">
          <svg viewBox="0 -8.25 512 512" xmlns="http://www.w3.org/2000/svg" fill="#144a6c" stroke="#144a6c">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <defs>
                <style>.cls-1 {
                  fill: none;
                  stroke: #1a2861;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                  stroke-width: 20px;
                }</style>
              </defs>
              <g data-name="Layer 2" id="Layer_2">
                <g data-name="E440, Archive, cabinet, drawer" id="E440_Archive_cabinet_drawer">
                  <path class="cls-1"
                  d="M371.47,304.77l-20.08,40.16H160.61l-20.08-40.16H40.12A30.12,30.12,0,0,0,10,334.89V455.38A30.12,30.12,0,0,0,40.12,485.5H471.88A30.12,30.12,0,0,0,502,455.38V334.89a30.12,30.12,0,0,0-30.12-30.12Z"></path>
                  <rect class="cls-1" height="40.16" rx="20.08" width="251.02" x="130.49" y="395.14"></rect>
                  <path class="cls-1" d="M502,324.85,456.49,88.22a30.13,30.13,0,0,0-29.58-24.43H254.05"></path>
                  <path class="cls-1" d="M10,324.85,55.5,88.22a30.13,30.13,0,0,1,25-24.08"></path>
                  <path class="cls-1"
                  d="M80.29,304.77v-99a21.51,21.51,0,0,1,21.51-21.52H215.71A21.5,21.5,0,0,1,236,198.6l17.84,39.47H410.2a21.51,21.51,0,0,1,21.51,21.51v45.19"></path>
                  <path class="cls-1"
                  d="M80.29,304.77v-180a21.5,21.5,0,0,1,21.51-21.51H215.71A21.51,21.51,0,0,1,236,117.55L253.82,157H410.2a21.51,21.51,0,0,1,21.51,21.52V304.77"></path>
                  <path class="cls-1"
                  d="M431.71,253.45a21,21,0,0,0,.25-3.19V85.31a21.52,21.52,0,0,0-21.52-21.52H254.05L236.22,24.32A21.5,21.5,0,0,0,216,10H102A21.51,21.51,0,0,0,80.53,31.52v90"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="p-4">
        <h1 class="font-bold tracking-wide text-center text-gray-700 text-2xl">Ocorrência Fechada</h1>
        <h1 class="text-center">A ocorrência que você procura encontra-se fechada e não pode ser acedida</h1>
      </div>
    </div>
  </main>
}

@if (!isEventLoading && !isTerminated) {
  <main>
    <div class="max-w-screen-xl px-4 py-8 mx-auto sm:px-6 lg:px-8 text-black">
      <!-- breadcrumb -->
      <nav class="container flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1">
          <!-- home -->
          <li class="inline-flex items-center">
            <a routerLink="/" class="ml-1 inline-flex text-sm font-medium text-gray-800 hover:underline md:ml-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
            </a>
          </li>
          <!-- category -->
          <li>
            <div class="flex items-center">
              <span class="mx-2.5 text-gray-800 ">/</span>
              <a routerLink="/ocorrencias" [queryParams]="{padrao: event.category.code}" class="ml-1 text-sm font-medium text-gray-800 hover:underline md:ml-2">
                {{event.category.description}}
              </a>
            </div>
          </li>
          <!-- title -->
          <li aria-current="page">
            <div class="flex items-center">
              <span class="mx-2.5 text-gray-800 ">/</span>
              <span class="ml-1 text-sm font-medium text-gray-800">
                {{event.title}}
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <!-- event card information -->
      <section class="text-gray-600 body-font container py-8 mx-auto ">
        <section class="bg-gray-100 p-4 lg:p-5">
          <div class="bg-white grid grid-cols-3 shadow">
            <!-- image -->
            <div class="">
              <app-image [event]="event"></app-image>
            </div>
            <!-- ocurrence details -->
            <div class="col-span-3 lg:col-span-2">
              <div class="p-10">
                <!-- title and description -->
                <div class="flex justify-between">
                  <h2 class="text-2xl font-bold text-gray-800 md:text-3xl">{{ this.event?.title }}</h2>
                  <div>
                    <app-ae-button variant="primary" type="button" size="sm" styleClass="p-button-sm"
                    (buttonClick)="setMouseEvent($event)" icon="pi pi-cog"></app-ae-button>
                  </div>
                </div>
                <p class="my-8 text-gray-600 text-sm">{{ this.event.description }}</p>
                <hr>
                  <!-- Information header-->
                  <div class=" flex space-x-2  mt-4 mb-2 text-gray-700">
                    <div><i class="pi pi-id-card" style="font-size: 1.5rem"></i></div>
                    <h1 class=" font-bold tracking-wide">informações</h1>
                  </div>
                  <div class="grid grid-cols-4  md:space-x-2">
                    <!-- event details left -->
                    <div class="col-span-4 md:col-span-2 space-y-2 text-sm">
                      <!-- referencia -->
                      <p>Referência: {{ event.reference}}</p>
                      <!-- if people -->
                      @if (event.category.code === 'PEOPLE') {
                        <!--gender birthdate-->
                        <p><span>Data de Nascimento: 28-01-1995 @if (event?.personFilter?.age) {
                          <span>({{event?.personFilter?.age}})</span>
                        }</span>
                        <p><span>Genero: Masculino</span>
                        <p>
                          <span>Outros Nomes:  {{ !event.personFilter.names ? notInformedText : event.personFilter.names | titlecase }}</span>
                        </p>
                      }
                      <!-- if vehicle -->
                      @if (event.category.code === 'VEHICLE') {
                        <p>Marca & Modelo: {{ event.vehicleFilter.brand + ', ' + event.vehicleFilter.model }}</p>
                        <p>Matricula: {{ event.vehicleFilter.licensePlate }}</p>
                        <p>Chassi: {{ event.vehicleFilter.chassiNumber ?? notInformedText }}</p>
                      }
                      <!-- if document -->
                      @if (event.category.code === 'DOCUMENT') {
                        <div>
                          <p>Tipo de
                          documento: {{ !event.documentFilter.type?.description ? notInformedText : event.documentFilter.type.description | titlecase }}</p>
                          <p>Entidade
                          emissora: {{ !event.documentFilter.entity ? notInformedText : event.documentFilter.entity | titlecase }}</p>
                        </div>
                      }
                      <!-- if other -->
                      @if (event.category.code === 'OTHER' || event.category.code === 'DOCUMENT') {
                        <p>Identificação: {{ !event.identification ? notInformedText : event.identification}}</p>
                      }
                      <p class="space-y-2 text-sm">
                      Local: {{ this.event.province.description | titlecase }}{{ ', ' + event.eventDate }} </p>
                      <ng-container class="space-y-2 text-sm">
                        <p> Contacto:
                          <!-- add the number -->
                          @if (this.event.hasContactAccess) {
                            <span class="font-bold"> {{ this.event.contact }} </span>
                          }
                          @if (!this.event.hasContactAccess) {
                            <span (click)="showContactDialog()"
                            class="underline cursor-pointer font-medium">Solicitação de Contacto</span>
                          }
                        </p>
                        <!-- contact request dialog -->
                        @if (!this.event.hasContactAccess) {
                          <app-contactrequest
                          [eventId]="event.id"></app-contactrequest>
                        }
                      </ng-container>
                    </div>
                    <!-- Event details right -->
                    <div class="col-span-4 md:col-span-2 mt-10 md:mt-0 space-y-2 text-sm">
                      <div class="flex flex-wrap items-center gap-2">
                        <span [pTooltip]="displayStatusToolTip()" tooltipPosition="top"
                          (click)="showAdjustmentMessage()"
                          class="cursor-pointer rounded bg-blue-300 p-2 text-white">Estado: {{ this.event.status?.description }}</span>
                        <span [ngClass]="event.intent?.code === 'FOUND'
                          ? 'rounded bg-emerald-600 p-2 font-semibold text-white'
                          : 'rounded bg-[#ff7900] p-2 font-semibold text-white'">Intenção: {{ event.intent?.description ?? 'À procura' }}</span>
                      </div>
                    <p>Reportado por: {{ this.event.account?.firstname + ' ' + this.event.account?.lastname }}</p>
                    <p>Recompensa: {{ this.event?.reward ?? "Sem recompensa" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <!--botton view -->
      @if (authUser?.id === event?.account.id) {
        <ng-container class="card">
          <app-contact-request-list [event]="event"></app-contact-request-list>
        </ng-container>
      }
    </div>
    <app-event-drop-down-menu
      (onEventRemoveSuccess)="onModalEventRemove()"
      (onCloseEventSuccess)="onCloseEvent()"
    [event]="event" [isAdmin]="false" [clickEvent]="mouseEvent"></app-event-drop-down-menu>
    <app-modal [isShow]="showAdjustmentModal" (cancel)="showAdjustmentModal = false"
      [header]="'Mensagem de Ajuste'">{{ this.event?.outcomeMessage }}
    </app-modal>
  </main>
}
